// Claimant Reps info form config
import { CHO_FCA_STATUS_OPTIONS, FIRST_NOTIFICATION_OPTIONS } from '../constants';
export const claimantRepsFields = [
    {
        key: 'credit-hire-organisation-information',
        name: 'Credit Hire Organisation Information',
        fields: [
            // {
            //     name: 'credit_hire_organisation',
            //     label: 'Credit Hire Organisation',
            //     type: 'text',
            //     validation: {}
            // },
            {
                name: 'cho_id',
                label: 'Credit Hire Organisation',
                type: 'dropdown',
                dropdownOptionsAPI: 'chos',
                validation: [{ name: 'required' }],
            },
            {
                name: 'kyo_link',
                label: 'KYO Link',
                type: 'link'
            },
            {
                name: 'cho_abi_gta_member',
                label: 'Credit Hire Organisation ABI GTA Member',
                type: 'boolean',
                validation: [{ name: 'required' }],
            },
            {
                name: 'cho_fca_status',
                label: 'Credit Hire Organisation FCA Status',
                type: 'dropdown',
                dropdownOptions: CHO_FCA_STATUS_OPTIONS,
                validation: {},
            },
            {
                name: 'cho_ref',
                label: 'Credit Hire Organisation Reference',
                type: 'text',
                validation: {},
            },
            {
                name: 'cho_address',
                label: 'Credit Hire Organisation Address',
                type: 'text',
                validation: {},
            },
            {
                name: 'cho_postcode',
                label: 'Credit Hire Organisation Post Code',
                type: 'text',
                validation: {},
            },
            {
                name: 'cho_contact_nb_live_hire',
                label: 'Credit Hire Organisation Contact Number - Live Hire',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'cho_contact_nb_settlement',
                label: 'Credit Hire Organisation Contact Number - Settlement',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'cho_email_address_live_hire',
                label: 'Credit Hire Organisation Email Address - Live Hire',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'email' }],
            },
            {
                name: 'cho_email_address_settlement',
                label: 'Credit Hire Organisation Email Address - Settlement',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'email' }],
            },
            {
                name: 'approved_ra',
                label: 'Approved RA',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'method_of_first_notification',
                label: 'Method of first notification',
                type: 'dropdown',
                dropdownOptions: FIRST_NOTIFICATION_OPTIONS,
                validation: {},
            },
            {
                name: 'is_credit_hire_being_provided',
                label: 'Is Credit Hire being Provided?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'is_credit_repair_being_provided',
                label: 'Is Credit Repair being Provided?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'is_recovery_being_provided',
                label: 'Is Recovery being provided?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'is_storage_being_provided',
                label: 'Is Storage being provided?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'is_dimuntion_being_claimed',
                label: 'Is diminution being claimed?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'are_any_other_losses_being_claimed',
                label: 'Are any other losses being claimed?',
                type: 'boolean',
                validation: {},
            },
        ],
    },
    {
        key: 'claimant-solicitors-information',
        name: 'Claimant Solicitors Information',
        fields: [
            {
                name: 'claimant_solicitor_involved',
                label: 'Claimant Solicitor Involved?',
                type: 'boolean',
                dependencySource: true,
                dependencyMatchValue: 1,
                validation: {},
            },
            {
                name: 'claimant_solicitor_name',
                label: 'Claimant Solicitor Name',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'claimant_solicitor_involved',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'claimant_solicitor_ref',
                label: 'Claimant Solicitor Reference',
                type: 'text',
                validation: {},
                dependency: {
                    type: 'visibility',
                    sourceField: 'claimant_solicitor_involved',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
            },
            {
                name: 'claimant_solicitor_address',
                label: 'Claimant Solicitor Address',
                type: 'text',
                validation: {},
                dependency: {
                    type: 'visibility',
                    sourceField: 'claimant_solicitor_involved',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
            },
            {
                name: 'claimant_solicitor_postcode',
                label: 'Claimant Solicitor Post Code',
                type: 'text',
                validation: {},
                dependency: {
                    type: 'visibility',
                    sourceField: 'claimant_solicitor_involved',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
            },
            {
                name: 'claimant_solicitor_contact_nb_live_hire',
                label: 'Claimant Solicitor Contact Number - Live Hire',
                type: 'text',
                validation: {},
                dependency: {
                    type: 'visibility',
                    sourceField: 'claimant_solicitor_involved',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'claimant_solicitor_contact_nb_settlement',
                label: 'Claimant Solicitor Contact Number - Settlement',
                type: 'text',
                validation: {},
                dependency: {
                    type: 'visibility',
                    sourceField: 'claimant_solicitor_involved',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                modalValidation: [{ name: 'phoneNumber' }],
            },
            {
                name: 'claimant_solicitor_email_address_live_hire',
                label: 'Claimant Solicitor Email Address - Live Hire',
                type: 'text',
                validation: {},
                dependency: {
                    type: 'visibility',
                    sourceField: 'claimant_solicitor_involved',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                modalValidation: [{ name: 'email' }],
            },
            {
                name: 'claimant_solicitor_email_address_settlement',
                label: 'Claimant Solicitor Email Address - Settlement',
                type: 'text',
                validation: {},
                dependency: {
                    type: 'visibility',
                    sourceField: 'claimant_solicitor_involved',
                    matchValue: 1, // this field will be visible when "are_all_documents_present" is 0
                },
                modalValidation: [{ name: 'email' }],
            },
        ],
    },
];
